import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
} from "@/components/ui/alert-dialog";
import { Button } from "./button";

interface ConfirmPopupProps {
  isOpen: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmPopup: React.FC<ConfirmPopupProps> = ({
  isOpen,
  title = "Are you sure?",
  message = "This action cannot be undone.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => { if (!open) onCancel(); }}>
      <AlertDialogContent className="z-[100] bg-white dark:bg-[#0f172a] rounded-2xl shadow-2xl p-4 sm:p-6 w-[calc(100vw-2rem)] max-w-[340px] sm:max-w-sm text-center border border-gray-200 dark:border-gray-800">
        <AlertDialogHeader className="text-center sm:text-center space-y-1.5 sm:space-y-2">
          <AlertDialogTitle className="text-base sm:text-xl font-bold text-gray-900 dark:text-white text-center leading-snug">
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-gray-600 dark:text-gray-300 text-center text-xs sm:text-sm leading-relaxed px-1">
            {message}
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="flex flex-row items-center justify-center gap-2 sm:gap-3 sm:justify-center sm:space-x-0 w-full mt-3 sm:mt-4">
          <Button
            type="button"
            variant="outline"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onCancel();
            }}
            className="flex-1 min-w-0 h-9 sm:h-10 px-2 sm:px-4 rounded-xl text-xs sm:text-sm font-semibold cursor-pointer border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-800 dark:hover:text-white transition-all duration-200 active:scale-95 truncate"
          >
            {cancelText}
          </Button>

          <Button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onConfirm();
            }}
            className="flex-1 min-w-0 h-9 sm:h-10 px-2 sm:px-4 rounded-xl text-xs sm:text-sm font-semibold cursor-pointer text-white bg-gradient-to-r from-[var(--bubble-own-from)] to-[var(--bubble-own-to)] hover:shadow-lg hover:shadow-[var(--accent)]/30 transition-all duration-200 active:scale-95 truncate"
          >
            {confirmText}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmPopup;
